export default __webpack_public_path__ + "2a271d4e9703bbc94c9f91b5ba71bcc1.png";